import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Button, InputGroup, InputGroupAddon, InputGroupText, Input, Alert, Form } from 'reactstrap';
import { authAttemptAdminLogin, clearAdminErrorMessage } from '../../../redux/actions/adminAuthActions';
import { get } from 'lodash-es';
import { FormattedMessage, injectIntl } from 'react-intl';
import AdminAuthContainer from '../../../containers/AdminAuthContainer';
import { Spinner } from '../../../containers/Spinner';

const mapStateToProps = state => {
  return {
    auth: state.auth,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    attemptAdminLogin: authPayload => dispatch(authAttemptAdminLogin(authPayload)),
    clearAdminErrorMessage: payload => dispatch(clearAdminErrorMessage(payload)),
  };
};

class AdminLogin extends Component {
  state = {
    errorMessage: null,
  };

  _runLogin = event => {
    event.preventDefault();
    const username = get(this.usernameTextInput, 'value').toLowerCase();
    const password = get(this.passwordTextInput, 'value');
    if (!username || !password) {
      this.setState({ errorMessage: this.props.intl.formatMessage({ id: 'loginPage.enterFields' }) });
    } else {
      this.props.attemptAdminLogin({ username, password });
    }
  };

  _handleKeyPress = e => {
    if (e.key === 'Enter') {
      e.preventDefault();
      this._runLogin(e);
    }
  };

  clearErrorOnValueChange = () => {
    if (get(this.props, 'auth.errorMessage', null)) {
      this.props.clearAdminErrorMessage({ errorMessage: null });
    }
    if (this.state.errorMessage) {
      this.setState({ errorMessage: null });
    }
  };

  render() {
    return (
      <AdminAuthContainer>
        <p className="text-muted text-center">
          <FormattedMessage id="loginPage.signInMsg" />
        </p>
        {(this.props.auth.errorMessage || this.state.errorMessage) && (
          <Alert color="danger" role="alert">
            {this.state.errorMessage || this.props.auth.errorMessage}
          </Alert>
        )}
        <Form onSubmit={this._runLogin}>
          <InputGroup className="mb-3">
            <InputGroupAddon addonType="prepend">
              <InputGroupText>
                <i className="icon-user" />
              </InputGroupText>
            </InputGroupAddon>
            <Input
              type="text"
              innerRef={input => {
                this.usernameTextInput = input;
              }}
              placeholder={this.props.intl.formatMessage({ id: 'loginPage.username' })}
              onKeyPress={this._handleKeyPress}
              onChange={this.clearErrorOnValueChange}
            />
          </InputGroup>
          <InputGroup className="mb-4">
            <InputGroupAddon addonType="prepend">
              <InputGroupText>
                <i className="icon-lock" />
              </InputGroupText>
            </InputGroupAddon>
            <Input
              type="password"
              innerRef={input => {
                this.passwordTextInput = input;
              }}
              placeholder={this.props.intl.formatMessage({ id: 'loginPage.password' })}
              onKeyPress={this._handleKeyPress}
              onChange={this.clearErrorOnValueChange}
            />
          </InputGroup>
          <Col xs="12" className="pl-0">
            <Button
              disabled={get(this.props, 'auth.loginInProgress', false)}
              color="primary"
              className="login-button"
              type="submit">
              {get(this.props, 'auth.loginInProgress', false) ? (
                <Spinner size="sm" />
              ) : (
                <FormattedMessage id="loginPage.login" />
              )}
            </Button>
          </Col>
        </Form>
      </AdminAuthContainer>
    );
  }
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(AdminLogin));
